import axiosInstance from "./axiosInstance";
import { HourReportingWorkflowDetail } from "./hourReportingApi";

export interface HourReportingSandboxTranscriptMessage {
    id: string;
    sender: 'assistant';
    kind: 'text' | 'interactive_buttons' | 'interactive_list' | 'raw';
    text: string;
    options: string[];
    createdAt: string;
    rawPayload?: Record<string, any> | null;
}

export interface HourReportingSandboxRequest {
    phoneNumber: string;
    body?: string;
    workflowId?: string;
    placementNumber?: number | null;
    declarationId?: string | null;
    interactiveButtonId?: string;
    interactiveListId?: string;
    interactiveTitle?: string;
    extractionOverrides?: {
        extraInstructions?: string | null;
        questionsOverride?: Array<Record<string, any>> | null;
        debug?: boolean | null;
    } | null;
    fileData?: {
        fileName?: string;
        mimeType?: string;
        caption?: string;
        contentBase64: string;
        sizeBytes?: number;
        type?: string;
    } | null;
}

export interface HourReportingSandboxResult extends HourReportingWorkflowDetail {
    claimed: boolean;
    workflowId: string | null;
    messages: HourReportingSandboxTranscriptMessage[];
}

export interface HourReportingSandboxWorkerOption {
    id: string;
    firstName: string;
    lastName: string;
    nationality?: string | null;
    whatsappId?: string | null;
    mobileNumber?: string | null;
    phoneNumber?: string | null;
    preferredPhone: string;
    easyflexRegistrationNumber?: number | null;
    activePlacementCount: number;
}

const BASE = "/timesheets/test";

export async function sendHourReportingSandboxMessage(
    payload: HourReportingSandboxRequest,
): Promise<HourReportingSandboxResult> {
    const response = await axiosInstance.post<HourReportingSandboxResult>(`${BASE}/messages`, payload);
    return response.data;
}

export async function getHourReportingSandboxOpenWorkflow(phoneNumber: string): Promise<HourReportingSandboxResult> {
    const response = await axiosInstance.get<HourReportingSandboxResult>(`${BASE}/open-workflow`, {
        params: { phoneNumber },
    });
    return response.data;
}

export async function resetHourReportingSandboxWorkflow(phoneNumber: string): Promise<HourReportingSandboxResult> {
    const response = await axiosInstance.post<HourReportingSandboxResult>(`${BASE}/reset`, {
        phoneNumber,
    });
    return response.data;
}

export async function fetchHourReportingSandboxWorkerOptions(
    search?: string,
    limit = 8,
): Promise<HourReportingSandboxWorkerOption[]> {
    const response = await axiosInstance.get<HourReportingSandboxWorkerOption[]>(`${BASE}/worker-options`, {
        params: {
            search: String(search ?? '').trim() || undefined,
            limit,
        },
    });
    return Array.isArray(response.data) ? response.data : [];
}
